import { ReferenceSections } from "../referenceSectionsEnum";

const RUNNER_URL: string = "https://geotab.github.io/sdk/software/api/runner.html";
export const WIP_STRING = "/* Work in progress - Coming soon */";

export interface RateLimit {
    name: string;
    limit: string;
    period: string;
    description: string;
    status: string;
}

type SortableEntry = [string, object];

export default function sortAlphabetical(a: SortableEntry, b: SortableEntry) {
    if (a[0] < b[0]) {
        return -1;
    }

    if (a[0] > b[0]) {
        return 1;
    }

    return 0;
}

export const getXmlUrl = (referenceSection: ReferenceSections): string =>
    referenceSection === ReferenceSections.MyGeotab ? "https://mypreview.geotab.com/sdk.xml" : process.env.REACT_APP_MYADMIN_URL!;

export const makeTryMeLink = (snippet: string): string => {
    let sample = {
        javascript: snippet,
        css: "",
        html: "",
        options: {
            js: true,
            css: false,
            html: false,
            console: true,
            output: true
        }
    };
    return RUNNER_URL + "#" + btoa(encodeURIComponent(JSON.stringify(sample)));
};
